import { create } from 'zustand';

type EmbedListIframeModalStore = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  setSharedToken: (sharedToken: string | null) => void;
  sharedToken: string | null;
};

export const useEmbedListIframeModalStore = create<EmbedListIframeModalStore>()(
  (set) => ({
    isOpen: false,
    setIsOpen: (isOpen) => set({ isOpen }),
    setSharedToken: (sharedToken) => set({ sharedToken }),
    sharedToken: null,
  }),
);
